export const ACTION_TYPES = {
  INITIALIZE_NAVIGATION_MIDDLEWARE: 'INITIALIZE_NAVIGATION_MIDDLEWARE',
  NAVIGATE: 'NAVIGATE'
};
